import { ActivityResponseDto } from '../dtos/activity/activity.response.dto';
import { ActivityRequestDto } from '../dtos/activity/activity.request.dto';
import { Activity } from '@domain/activity/activity';

export class ActivityMapper {
  static fromDto(dto: ActivityResponseDto): Activity {
    return new Activity(dto.id, dto.name, dto.active, dto.description);
  }

  static toRequestDto(entity: Activity): ActivityRequestDto {
    return {
      name: entity.name,
      description: entity.description,
      active: entity.active,
    };
  }
}
